import React from 'react'
import classes from './FloatSpinner.module.scss'

interface FloatSpinnerProps {
  textContent?: string | React.ReactNode
}

function FloatSpinner({ textContent }: FloatSpinnerProps) {
  return (
    <div className={classes.root}>
      <div className={classes.conteWrapper}>
        <div className={classes.txtContent}>{textContent && textContent}</div>
        <div className={classes.spinner}>
          <div className={classes.ldsRing}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(FloatSpinner)
